import React from 'react';
import PropTypes from 'prop-types';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import RxLookupForm from '../../components/Forms/RxLookupForm';
import HeroText from '../../components/HeroText';
import styles from './HomePageLayout.css';

const HomePageLayout = ({ getRxConnect, rxLookup }) => (
  <div className={styles.container}>
    <Header />
    <Menu dark />
    <HeroText />
    <RxLookupForm initialValues={rxLookup} onSubmit={getRxConnect} />
  </div>
);

HomePageLayout.propTypes = {
  getRxConnect: PropTypes.func.isRequired,
  rxLookup: PropTypes.object,
};

export default HomePageLayout;



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePageLayout.jsx